import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortList'
})
export class SortingListPipe implements PipeTransform {

  transform(list: any[], column: string, order: number , columnTypeNumber: boolean ): any[] {
    if (!list || !column || !order) { return list; }

    return list.sort((a: any[], b: any[]) => {
      let x, y;
        if (columnTypeNumber) {
              x = a[column];
              y = b[column];
        } else {
          x = a[column].toLocaleLowerCase();
          y = b[column].toLocaleLowerCase();
        }
        return x > y ? order : order * (- 1);
    });
  }
}
